<template slot-scope="tour">
  <transition>
    <v-step
      v-for="(step, index) of tour.steps"
      v-if="tour.currentStep === index"
      :key="index"
      :step="step"
      :previous-step="tour.previousStep"
      :labels="tour.labels"
      :next-step="tour.nextStep"
      :stop="tour.stop"
      :is-first="tour.isFirst"
      :is-last="tour.isLast"
    >
      <template>
        <div slot="actions">
          <button
            v-if="!tour.isLast"
            class="v-step__button"
            @click="setStop"
          >
            Pular tutorial
          </button>
          <button
            v-if="!tour.isFirst"
            class="v-step__button"
            @click="tour.previousStep"
          >
            Voltar
          </button>
          <button
            v-if="!tour.isLast"
            class="v-step__button"
            @click="tour.nextStep"
          >
            Próximo
          </button>
          <button
            v-if="tour.isLast"
            class="v-step__button"
            @click="setStop"
          >
            Concluir
          </button>
        </div>
      </template>
    </v-step>
  </transition>
</template>

<script>
export default {
  name: 'TourGuideModule',
  props: ['tour', 'steps', 'stop', 'setAsVisualized'],
  methods: {
    setStop() {
      this.setAsVisualized()
    }
  }
}
</script>
